import { PlanningPokerCard } from './PlanningPokerCard';
import type { PlanningPokerCard as PlanningPokerCardType } from '../types';

interface PlanningPokerCardListProps {
  cards: PlanningPokerCardType[];
  selectedCardId?: string;
  votedCardId?: string;
  disabled?: boolean;
  onCardClick?: (cardId: string) => void;
}

export const PlanningPokerCardList = ({
  cards,
  selectedCardId,
  votedCardId,
  disabled = false,
  onCardClick,
}: PlanningPokerCardListProps) => {
  return (
    <div className="w-full">
      <div className="flex flex-wrap justify-center gap-2">
        {cards.map((card) => (
          <PlanningPokerCard
            key={card.id}
            id={card.id}
            name={card.name}
            description={card.description}
            isSelected={selectedCardId === card.id}
            isVoted={votedCardId === card.id}
            disabled={disabled}
            onClick={() => onCardClick?.(card.id)}
          />
        ))}
      </div>
    </div>
  );
};
